(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamp-finder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input',function(event){if(!event.target.matches('.lf-brand-filter'))return;const query=event.target.value.trim().toLowerCase();event.target.closest('.lf-directory').querySelectorAll('[data-lf-brand]').forEach(function(link){link.hidden=!link.dataset.lfBrand.includes(query);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamp-product"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('button[data-lp-image]');
  if (!button) return;
  const gallery = button.closest('.lp-gallery');
  const mainImage = gallery?.querySelector('.lp-main-image');
  if (!mainImage) return;
  mainImage.removeAttribute('srcset');
  mainImage.removeAttribute('sizes');
  mainImage.src = button.dataset.lpImage;
  mainImage.alt = button.querySelector('img')?.alt || '';
  gallery.querySelectorAll('button[data-lp-image]').forEach((thumbnail) => {
    thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
